import SettingsHelper from "@/utils/SettingsHelper"
import {defineComponent} from "vue"

/*
    Mixin with misc utils
*/
export default defineComponent({
    computed: {
        isDevelopment(): boolean {
            const env = SettingsHelper.getSetting("environment")
            const environments = ["dev", "prod"]
            if (!environments.includes(env)) {
                throw new Error(`Invalid environment: ${env}`)
            }
            return SettingsHelper.getSetting("environment") !== "prod"
        },

        skipTeamLoginChecks(): boolean {
            const settings = (window as any)._settings
            return this.isDevelopment && settings.skipTeamLoginChecks === true
        }
    },

    methods: {
        getGameNameFromId(gameId: string) {
            return this.$t(`${gameId}.title`)
        }
    }
})
